
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { showModal } from '../../features/modal/modalSlice';
import { useDispatch } from 'react-redux';
import { getSSSItemData, updateSSSListOrder } from '../../features/adminSett/adminSettSlice';
import textBoldMaker from '../../helper/textBoldMaker';

  const Container = styled.div`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;


        .list-item{
          width: 100%;
          padding: 20px;
          display: flex;
          flex-direction: column;
          border-radius: 20px;
          border: 1px solid ${({theme}) => theme.mainBorderColor};
          color: ${({theme}) => theme.mainTextColor};
          background-color: ${({ theme }) => theme.secondaryBgColor};

          .question-container{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 5px;
            margin-bottom: 10px;
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
            font-weight: var(--font-weight-xl);
   
            .question{
           
            }

            .tools{
              display: flex;
              align-items: center;
              gap: 10px;

              .delete-link{
                text-decoration: underline;
                font-weight: var(--font-weight-lg);
                padding: 5px;
                padding-bottom: 2px;
                cursor: pointer;

                &:hover{
                  color: var(--color-red);

                }
              }
              .guncelle-link{
                text-decoration: underline;
                font-weight: var(--font-weight-lg);
                padding: 5px;
                padding-bottom: 2px;
                cursor: pointer;
                
                &:hover{
                  color: var(--color-green);
                }
              }
            }
          }

          .answer-wrapper{
            display: flex;
            gap: 5px;
            align-items: flex-start;
            .answer{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-md);


              .bold{
                font-weight: var(--font-weight-lg);
              }
            }
          }

          .key{
              font-weight: var(--font-weight-lg);
              font-size: var(--font-size-md);
              color: var(--color-main);
          }


        }
  `
  
const VerticalDndSSS = ({data}) => {

  const dispatch = useDispatch()

    const onDragEnd = (result) => {
      if (!result.destination) return; // Sürükleme hedefi yoksa
  
      const reorderedItems = Array.from(data);
      const [movedItem] = reorderedItems.splice(result.source.index, 1); // Öğeyi kaydır
      reorderedItems.splice(result.destination.index, 0, movedItem);
  
      dispatch(updateSSSListOrder(reorderedItems))
    };


  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sss">
        {(provided) => (
          <Container {...provided.droppableProps} ref={provided.innerRef}>
            {data?.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided) => (
                  <div
                   className='list-item'
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                  >
                  <div className="question-container">
                    <div className="question"><span className="key">Soru: </span>{index+1}- {item.question}</div>
                    <div className="tools">
                      <div className='guncelle-link'onClick={() =>  {dispatch(showModal("updateSSSItem")); dispatch(getSSSItemData(item))}}>Güncelle</div>
                      <div className='delete-link'onClick={() =>  {dispatch(showModal("deleteSSSItem")); dispatch(getSSSItemData(item))}}>Kaldır</div>
                    </div>
                  </div>
                  <div className="answer-wrapper">
                    <span className="key">Cevap: </span>
                    <div className="answer"  dangerouslySetInnerHTML={{ __html: textBoldMaker(item.answer) }}/>
                  </div>
                  </div>
                )}
              </Draggable>
            ))}
          </Container>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default VerticalDndSSS